import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.0354 3.01467C17.16 1.88995 18.9556 1.84497 20.134 2.87971L20.278 3.01467L20.9851 3.72177C22.1098 4.84649 22.1548 6.64205 21.1201 7.82042L20.9851 7.96441L9.77281 19.1767C9.61378 19.3357 9.42155 19.4564 9.21077 19.5307L9.04943 19.5776L4.59453 20.6057C3.91174 20.7632 3.29593 20.1918 3.37445 19.5184L3.39408 19.4053L4.42213 14.9503C4.4727 14.7312 4.57173 14.527 4.71109 14.3523L4.82306 14.227L16.0354 3.01467ZM15.3282 6.55026L6.33867 15.5398L5.70227 18.2975L8.45999 17.6611L17.4495 8.67158L15.3282 6.55026ZM18.8638 4.42888C18.5033 4.0684 17.9361 4.04067 17.5438 4.34569L17.4496 4.42888L16.7424 5.13605L18.8637 7.25737L19.5709 6.5502C19.9314 6.18972 19.9591 5.62249 19.6541 5.2302L19.5709 5.13599L18.8638 4.42888Z" })
});
export default SvgPencilLine;
